export default "/images/vendor/flag-icon-css/flags/4x3/lc.svg?c6488de9494a4e151cc47bdfadffdb4d";